
import { Component, Mixins, Prop } from "vue-property-decorator";
import { EditingDocument } from "../EditingDocument";

@Component
export default class DocumentReferableMixin extends Mixins() {
  @Prop()
  document: EditingDocument;

  readPropertyOrDefault<T>(read: (s: EditingDocument) => T, defaultValue: T) {
    return this.document
      ? read(this.document)
      : defaultValue;
  }
}
